<template>
  <div class="container">
    <headBox title="短险续保单"></headBox>
    <div class="info-content">
      <ath-title :num="num" :renewalType="renewalType"></ath-title>
      <!-- 搜索部分 -->
      <topSearchForm @search="queryOrderList" :hiddenExport="!checkAuth('orderExport')" @export="exportToExcel">
        <el-form :inline="true" class="rform" :model="dataForm" ref="loginform">
          <el-form-item label="" class="small">
            <div class="cell-border">
              <el-select class="left-select-big" v-model="dataForm.timeTitle" placeholder="到期日期">
                <el-option value="1" label="到期日期"></el-option>
                <el-option value="2" label="实际续保日期"></el-option>
              </el-select>
              <a-range-picker class="date-picker-big" v-model="dataForm.endTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
                <i class="icon-riqixuanze" slot="suffixIcon"></i>
              </a-range-picker>
            </div>
          </el-form-item>
          <el-form-item label="产品名称" class="small1">
            <el-input v-model="dataForm.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="">
            <div class="cell-border">
              <el-select v-model="dataForm.policyHolder" placeholder="投保人" class="left-select">
                <el-option label="投保人" value="1"></el-option>
                <el-option label="被保人" value="2"></el-option>
              </el-select>
              <el-input class="right-input" type="text" v-model="dataForm.nameOrPh" placeholder="姓名/手机号" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item label="">
            <div class="cell-border">
              <el-select v-model="dataForm.oldOrNewPolicy" placeholder="原保单号" class="left-select">
                <el-option label="原保单号" value="1"></el-option>
                <el-option label="续保单号" value="2"></el-option>
              </el-select>
              <el-input class="right-input" type="text" v-model="dataForm.originalNum" placeholder="请输入" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item label="" v-if="[1, 2].includes(userinfo.userLevel) && [1, 2].includes(userinfo.level * 1)">
            <div class="cell-border">
              <el-select
                class="left-select"
                v-model="dataForm.level"
                @change="
                  dataForm.mechanId = '';
                  dataForm.userId = '';
                "
                placeholder="出单团队"
              >
                <el-option label="出单团队" value="2"></el-option>
                <el-option label="出单员工" value="3"></el-option>
              </el-select>
              <el-select v-if="dataForm.level == 2" class="right-select" v-model="dataForm.mechanId" clearable filterable>
                <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
              </el-select>
              <el-select v-else-if="dataForm.level == 3" class="right-select" v-model="dataForm.userId" clearable filterable>
                <el-option :label="dept.name" :value="dept.id" v-for="(dept, index) in userList" :key="index"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- 只有二级团队显示 -->
          <el-form-item label="出单员工" v-if="[3].includes(userinfo.userLevel) && [2].includes(userinfo.level * 1)">
            <el-select v-model="dataForm.userId" clearable filterable>
              <el-option :label="dept.name" :value="dept.id" v-for="(dept, index) in userList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </topSearchForm>
      <el-tabs v-model="dataForm.renewal" @tab-click="queryOrderList" v-if="countData" :key="countData.count">
        <el-tab-pane label="全部" name="null"></el-tab-pane>
        <el-tab-pane :label="countData.count == 0 ? '待续保' : `待续保(${countData.count})`" name="2$1"></el-tab-pane>
        <el-tab-pane label="已续保" name="5"></el-tab-pane>
        <el-tab-pane label="续保失败" name="6$1"></el-tab-pane>
        <el-tab-pane label="不可续保" name="renewalStatusNe"></el-tab-pane>
      </el-tabs>
      <div class="list-second" v-loading="loading">
        <div class="list1">
          <xbd-card :orderList="renewalPolicys" v-if="renewalPolicys" @getRenewalPolicys="getRenewalPolicys" v-loading="loading" ref="child"></xbd-card>
        </div>
      </div>
      <el-pagination
        v-if="pageFlag"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="allData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="allData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allData.total"
      >
      </el-pagination>
    </div>
    <helpTool type="orderXB"></helpTool>
  </div>
</template>

<script>
import topSearchForm from '@/components/topSearchForm.vue';
import headBox from '@/components/head.vue';
import xbdCard from './components/order_xbd_card';
import athTitle from './components/authorizationTitle';
import helpTool from '@/components/helpTool.vue';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data: () => ({
    pageFlag: false,
    loading: true,
    num: 3, // 授权标题
    mechanType: '1', // 默认选中的tab,1全部 2我的 3下级团队 4员工
    pageNum: 1,
    pageSize: 10,
    allData: {},
    countData: null,
    renewalPolicys: [],
    renewalType: '1', // 1 短险续保列表 2 长险续费列表
    dataForm: {
      timeTitle: '1', // 1到期日期 2实际续保日期
      endTime: [], // 到期日期
      productName: '', // 产品名称
      nameOrPh: '', // 姓名或者手机
      policyHolder: '1', // 投保人
      originalNum: '', // 新旧保单号
      renewal: '2$1', // 续保状态
      oldOrNewPolicy: '1', //新旧保单号 1原保单号 2续保单号
      level: '2', // 2出单团队/3出单员工
      mechanId: '', // 出单员工/团队id
      userId: ''
    },
    childrenRefs: [],
    userinfo: {},
    // screenWidth: document.body.clientWidth, // 屏幕宽度
    timer: false,
    selectList: [], // 出单团队/员工列表
    userList: []
  }),
  created() {
    this.getUserInfo();
  },
  mounted() {
    this.getRenewalPolicys();
  },
  methods: {
    getUserList() {
      this.$http({
        url: '/master/subAccount/queryUsersList',
        type: 'PUT',
        params: {}
      })
        .then(res => {
          if (res.httpCode == 200) {
            this.userList = res.data;
          }
        })
        .catch(e => {});
    },
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data) {
      let val = data.map(item => {
        if (item.children.length == 0) {
          item.children = '';
        } else {
          this.handleDeptTree(item.children);
        }
        return item;
      });
      return val;
    },
    // 获取团队/员工列表
    getChildList() {
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: {
          includeFirst: '1'
        }
      })
        .then(res => {
          if (res.httpCode == 200) {
            this.selectList = res.data;
          }
        })
        .catch(e => {});
    },
    getUserInfo() {
      const data = this.$tools.getLocal('userinfo');
      this.userinfo = this.$tools.getLocal('userinfo');
      // 1一级团队 2二级团队 3员工
      if (data.userLevel == 1 || (data.level == 2 && data.userLevel == 2)) {
        // 一级团队默认出单团队
        this.dataForm.level = '2';
        this.getChildList(); // 获取出单团队列表
        this.getUserList();
      } else if (data.level == 2) {
        //二级团队没有出单团队，默认出单员工
        this.dataForm.level = '3';
        this.getUserList();
      }
    },
    // 查询
    queryOrderList() {
      this.pageNum = 1;
      this.getRenewalPolicys();
    },
    // 获取参数
    getParams() {
      const begin = this.dataForm.endTime.length != 0 ? this.dataForm.endTime[0] : '';
      const end = this.dataForm.endTime.length != 0 ? this.dataForm.endTime[1] : '';
      const params = {
        renewalTimeStart: this.dataForm.timeTitle == '2' ? begin : '', // 实际续保日期
        renewalTimeEnd: this.dataForm.timeTitle == '2' ? end : '', // 实际续保日期
        endTimeStart: this.dataForm.timeTitle == '1' ? begin : '', // 到期开始时间
        endTimeEnd: this.dataForm.timeTitle == '1' ? end : '', // 到期结束时间
        productName: this.dataForm.productName,
        policyerKey: this.dataForm.policyHolder == '1' ? this.dataForm.nameOrPh : '', // 搜索默认为投保人,
        insuranceKey: this.dataForm.policyHolder == '2' ? this.dataForm.nameOrPh : '',
        policyNo: this.dataForm.oldOrNewPolicy == '1' ? this.dataForm.originalNum : '', // 原保单号
        type: this.dataForm.renewal, //续保状态
        mechanType: this.mechanType,
        renewalType: this.renewalType, // 1 短险续保列表 2 长险续费列表
        mechanId: this.dataForm.mechanId, // 出单团队/员工id
        userId: this.dataForm.userId,
        newPolicyNo: this.dataForm.oldOrNewPolicy == '2' ? this.dataForm.originalNum : '' //新保单号
      };
      if (this.dataForm.nameOrPh == '') {
        delete params.policyerKey;
      }
      if (params.type.includes('$')) {
        const arr = params.type.split('$');
        params.type = arr[0];
        params.isRenewal = arr[1];
      } else if (params.type == 'null') {
        delete params.type;
      } else if (params.type == 'renewalStatusNe') {
        // 特殊处理
        delete params.type;
        params.isRenewal = '0';
        params.renewalStatusNe = '5';
      }
      for (var key in params) {
        if (params[key] == '') {
          delete params[key];
        }
      }
      return params;
    },
    // 获取续费列表
    getRenewalPolicys() {
      this.loading = true;
      const query = this.getParams();
      query.pageNum = this.pageNum;
      query.pageSize = this.pageSize;
      this.getCount();
      this.$http({
        url: '/master/policy/queryRenewalPolicys',
        type: 'put',
        params: query
      }).then(res => {
        this.loading = false;
        this.pageFlag = false;
        this.renewalPolicys = res.data;
        this.allData = res;
        if (this.allData.total != 0) {
          this.pageFlag = true;
        }
      });
    },
    getCount() {
      const query = this.getParams();
      delete query.type;
      delete query.isRenewal;
      this.$http({
        url: '/master/policy/countRenewalPolicys',
        type: 'put',
        params: query
      }).then(res => {
        this.countData = res.data[0] || {};
      });
    },
    // 导出
    exportToExcel() {
      const query = this.getParams();
      if (query.productName) {
        query.productName = this.handleProductName(query.productName);
      }
      const params = {
        path: '/master/policy/exportRenewalPolicys',
        query
      };
      const url = this.$router.resolve(params).href.replace('#/', '/');
      console.log('续保单页面导出', url);
      // 当前页面下载
      this.$tools.daochu(url);
    },
    handlePaneClick(tab) {
      this.pageNum = 1;
      this.mechanType = tab.name;
      this.getRenewalPolicys();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRenewalPolicys();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getRenewalPolicys();
    },
    // 转译特殊字符
    handleProductName(name) {
      return name
        .replace(/\+/g, '%2B')
        .replace(/\-/g, '%2D')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace('\n', '%20');
    }
  },
  components: {
    xbdCard,
    athTitle,
    helpTool,
    headBox,
    topSearchForm
  }
};
</script>

<style lang="scss" scoped>
@import './order_xbd';
</style>
